import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { updateUserSchedule, deleteUserSchedule } from "actions/Settings";
import SelectInput from "components/SelectInput";
import ButtonContained from "components/ButtonContained";

const UserSettingsScheduleModal = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const user = useSelector(state => state.users.userObject);
  const site = useSelector(state => state.auth.site);
  const schedules = useSelector(state => state.settings.siteSchedules);
  const [schedule, setSchedule] = useState(null);

  useEffect(() => {
    if (user) {
      if (user.role?.userSiteHoursSuiteUUID === "0") {
        setSchedule(null);
      } else {
        setSchedule(user.role?.userSiteHoursSuiteUUID);
      }
    }
  }, [user]);

  const handleSave = () => {
    dispatch(updateUserSchedule(
      {
        userUUID: user.uuid,
        userSiteHoursSuiteUUID: schedule
      },
      {
        facilityUUID: site.uuid,
        companyUUID: site.companyUUID,
        message: intl.formatMessage({ id: "notifications.success.edit" }),
        refetch: true
      }
    ));
  }

  const handleDelete = () => {
    dispatch(deleteUserSchedule(
      {
        userUUID: user.uuid
      },
      {
        message: intl.formatMessage({ id: "notifications.success.delete" }),
        refetch: true
      }
    ));
  }

  return (
    <div className="min-h-[300px] px-10 pt-4 flex flex-col justify-between">
      <div className="flex flex-col gap-4">
        <div>
          <h5 className="tw-heading-5 mb-4">{intl.formatMessage({ id: "pages.schedules.Type" })}</h5>
        </div>
        <SelectInput
          id="User-Settings-Schedule-Input"
          dataCy="User-Settings-Schedule-Input"
          value={schedule || ""}
          placeholder={schedule ? intl.formatMessage({ id: "pages.users.schedule.type" }) : intl.formatMessage({ id: "comp.header.select.schedule" })}
          onChange={(e) => setSchedule(e.target.value)}
          disabled={site && site.pms === "breeze" && user?.role?.tier === 0 ? true : false}
          options={
            schedules
              ? schedules.map(s => ({
                value: s.userSiteHoursSuiteUUID,
                name: s.name
              }))
              : []
          }
        />
      </div>
      <div className="flex justify-between">
        <ButtonContained
          id="User-Settings-Schedule-Save-Changes-Button"
          dataCy="User-Settings-Schedule-Save-Changes-Button"
          text={intl.formatMessage({ id: "comp.button.saveChanges" })}
          type="medium"
          disabled={!user || !schedule || (schedule === user?.role?.userSiteHoursSuiteUUID)}
          onClick={() => handleSave()}
        />
        <ButtonContained
          id="User-Settings-Schedule-Delete-Button"
          dataCy="User-Settings-Schedule-Delete-Button"
          text={intl.formatMessage({ id: "pages.users.deleteSchedule" })}
          type="medium"
          overrideColor="bg-[var(--color-alert)]"
          onClick={() => handleDelete()}
        />
      </div>
    </div>
  )
};

export default UserSettingsScheduleModal;
